import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';
import { useCallback } from 'react';
import FilterContainer from '../../../../Tracking/components/NFFilters/components/FilterContainer';
import { cpfOrCnpjMask, customersMask } from '../../../../Tracking/components/NFFilters/masks';
import { luftGet } from '../../../../../shared/http';
import { LOCAL_STORAGE_USER_TYPE } from '../../../../../shared/http/auth';
import FilterForm from '../../../../Tracking/components/NFFilters/components/FilterForm';
import { USER_TYPES } from '../../../../Admin/shared/static-options';
import CheckboxControl from '../../../../Tracking/components/NFFilters/components/CheckboxControl';
import InfinityContent from '../../../../Tracking/components/NFFilters/components/InfinityContent';

const Subsidiaries = ({ 
  isOpen, 
  onClick, 
  onApply, 
  listCompany,
  byDate,
  initialPeriod,
  finalPeriod 
}) => {
  const [selectedItem, setSelectedItem] = useState(listCompany);
  const [atualPage, setAtualPage] = useState(1);
  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [loading, setLoading] = useState(false);
  const [queryParamas, setQueryParams] = useState();
  const [totalLines, setTotalLines] = useState();

  const companyId = window.localStorage.getItem('Luft/CustomerService/CompanyId') || window.localStorage.getItem('Luft/CompanyId');

  const params = {
    page: atualPage,
    amount: 10,
    byDate,
    initialPeriod,
    finalPeriod,
    companyId,
  };

  const fetchAllSubsidiaries = async () => {
    if (loading) {
      return;
    }
    try {
      setLoading(true);

      const response = await luftGet(
        '/IntegratedTracking/GetIntegratedTrackingCompanies',
        params,
      );
      setData(prevData => [...prevData, ...response.data]);
      setTotalLines(data.length);
      setAtualPage(prevPage => prevPage + 1);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setAtualPage(0);
    setData([]);
    fetchAllSubsidiaries();
  }, [ 
    byDate,
    initialPeriod,
    finalPeriod
  ]);

  const handleSearchByCustomer = async e => {
    e.preventDefault();
    setQueryParams(e.target.value);   
    await debounceFilteredByCustomers(e);
  };

  const fetchFilterByCustomer = async e => {
    setLoading(true);
    try {
      const newParams = {
        ...params,
        page: 1,
        query: e.target.value.toLocaleLowerCase().trim(),
      };

      const response = await luftGet(
        '/IntegratedTracking/GetIntegratedTrackingCompanies',
        newParams,
      );
      setDataFilter(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const debounceFilteredByCustomers = useCallback(debounce(fetchFilterByCustomer, 1000), []);

  const handleChange = e => {
    if (!e.target.checked) {
      setSelectedItem(
        selectedItem.filter(item => Number(item) !== Number(e.target.value)),
      );
    } else if (e.target.checked) {
      setSelectedItem([...selectedItem, e.target.value]);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    onApply(selectedItem);
  };

  const clearFilter = () => {
    setSelectedItem([]);
    onApply([]);
  };

  const clearSearch = () => {
    setQueryParams('');
  };

  const userType = window.localStorage.getItem(LOCAL_STORAGE_USER_TYPE);

  return (
    <FilterContainer
      label="Filial Emissora"
      isOpen={isOpen}
      onClick={onClick}
      alignDropdownRight
    >
      <FilterForm
        label={
          USER_TYPES.CUSTOMER_SERVICE_USER === Number(userType)
            ? 'Filtrar por filial emissora (Cliente)'
            : 'Filtrar por filial emissora'
        }
        onSubmit={handleSubmit}
        clearFilter={clearFilter}
      >
        <InfinityContent
          inputSearchLabel="Buscar filial"
          searchChange={handleSearchByCustomer}
          clearSearch={clearSearch}
          data={data}
          dataFiltered={dataFilter}
          fetchAllData={() => fetchAllSubsidiaries()}
          hasMore={
            dataFilter.length !== 0
              ? dataFilter.length < totalLines
              : data.length < totalLines
          }
          queryParamas={queryParamas}
          loading={loading}
        >
          {(queryParamas ? dataFilter : data).map(filter => {
            if (filter.location && filter.cnpjEmit) {
              return (
                <CheckboxControl
                  key={filter.cnpjEmit}
                  value={filter.cnpjEmit}
                  onChange={handleChange}
                  defaultChecked={selectedItem.some(
                    item => parseInt(item) === Number(filter.cnpjEmit),
                  )}
                  title={customersMask(filter.location)}
                  description={cpfOrCnpjMask(filter.cnpjEmit.trim())}
                  infinityList
                />
              )
            }
          })}
        </InfinityContent>
      </FilterForm>
    </FilterContainer>
  );
};

const mapStateToProps = state => ({
  listCompany: state.carbon.filters.listCompany,
  byDate: state.tracking.filters.byDate,
  initialPeriod: state.carbon.filters.initialPeriod,
  finalPeriod: state.carbon.filters.finalPeriod,
});

export default connect(mapStateToProps)(Subsidiaries);
